import {
  getInitializeLandingSEOPageDataStore,
  LandingSEOPageDataStore,
} from '@doltech/modules/lib/landing-home/model/landingPageData.store';
import { getInitializeViewTestSolution } from '@doltech/modules/lib/view-solution/model/view-solution.hook';
import { ViewSolutionStore } from '@doltech/modules/lib/view-solution/model/view-solution.store';
import { getInitializeViewTestSubjectStore } from '@doltech/modules/lib/view-test-subject/model/view-test-subject.hook';
import { ViewTestSubjectStore } from '@doltech/modules/lib/view-test-subject/model/view-test-subject.store';
import { ViewTestSubjectLayout } from '@doltech/modules/lib/view-test-subject/ViewTestSubjectLayout';
import { DynamicPageProps } from '@doltech/routeDefinition';
import { SharedFooter } from '@doltech/ui/lib/figma/Layout/Landing/Footer/SharedFooter';
import { useCreateStore, useProvider } from 'mobx-store-provider';
import * as React from 'react';

interface ViewTestQuestionTemplatePageProps extends DynamicPageProps {}

const ViewTestQuestionTemplatePage = (props: ViewTestQuestionTemplatePageProps) => {
  const { pageData, seoData, data } = props;
  const { pageDetail } = pageData;

  const viewTestSubjectCreateStore = useCreateStore(
    ViewTestSubjectStore,
    getInitializeViewTestSubjectStore(data, data.testType)
  );
  const ViewTestSubjectStoreProvider = useProvider(ViewTestSubjectStore);

  const viewSolutionCreateStore = useCreateStore(
    ViewSolutionStore,
    getInitializeViewTestSolution(data, data.testType)
  );

  const ViewSolutionStoreProvider = useProvider(ViewSolutionStore);

  const landingSEOPageDataCreateStore = useCreateStore(
    LandingSEOPageDataStore,
    getInitializeLandingSEOPageDataStore({
      pageData: pageDetail,
      seoData,
    })
  );

  const LandingSEOPageDataStoreProvider = useProvider(LandingSEOPageDataStore);
  return (
    <LandingSEOPageDataStoreProvider value={landingSEOPageDataCreateStore}>
      <ViewTestSubjectStoreProvider value={viewTestSubjectCreateStore}>
        <ViewSolutionStoreProvider value={viewSolutionCreateStore}>
          <ViewTestSubjectLayout {...props} />
          <SharedFooter />
        </ViewSolutionStoreProvider>
      </ViewTestSubjectStoreProvider>
    </LandingSEOPageDataStoreProvider>
  );
};

export default ViewTestQuestionTemplatePage;
